module.exports = __webpack_public_path__ + "static/media/icons-rocket.c8fb0421.png";